import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
//import '@/firebase';

import VCharts from 'v-charts'
Vue.use(VCharts)

import { rtdbPlugin } from 'vuefire'
Vue.use(rtdbPlugin)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

Vue.config.productionTip = false
// import app from '@/firebase'

new Vue({
  vuetify,
  router,
  render: h => h(App),
  // created() { //2nd way for firebase
  // app()
  // } 
}).$mount('#app')

